import service from './index'
import apiService from './apiService'

const resource = service.resource('races/get-races-by-trainer{/id}')

export default {
  // Read legacy
  get (id) {
    return resource.get({id: id})
  },
  
  // Node.js paginated API
  getAllRuns (params) {
    // Create query string from params object manually
    const queryString = Object.keys(params)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key] || ''))
      .join('&')
      
    const url = `api/Runs/GetAll?${queryString}`
    
    return apiService.get(url).then(response => {
      // Ensure the returned object matches what vue-resource returns (has `body` property)
      return { body: response.data }
    })
  }
}




// WEBPACK FOOTER //
// ./src/services/racesByTrainer.js